import React from 'react'
import Cart from '../features/cart/Components/Cart';

const CartPage = () => {
    document.title = "Cart Information";
    return (
        <>
        <Cart />
        </>
    )
}

export default CartPage